/**
 * @selector [data-js-siteheader]
 * @enabled true
 */
import { default as BaseModule, getRefs } from '../../modules/BaseModule.js';
import Headroom from 'headroom.js';
import fastdom from 'fastdom';
import { createMachine, interpret } from '@xstate/fsm';

export default class SiteHeader extends BaseModule {
    init(element) {
        this.el = element;
        this.$refs = getRefs(this.el, 'data-js-siteheader');

        this.service = interpret(
            createMachine({
                initial: 'absolute',
                states: {
                    absolute: {
                        on: {
                            UNPIN: 'unpinned',
                        },
                    },
                    pinned: {
                        on: {
                            UNPIN: 'unpinned',
                            AT_PAGE_TOP: 'absolute',
                        },
                    },
                    unpinned: {
                        on: {
                            PIN: 'pinned',
                            AT_PAGE_TOP: 'absolute',
                        },
                    },
                },
            }),
        ).start();

        this.service.subscribe((state) => this.onStateChange(state));

        this.syncHeight();
        this.setup();
        this.onScroll({});
        this.bindListeners();

        return this;
    }

    onStateChange(state) {
        fastdom.mutate(() => {
            this.el.dataset.previousState = this.el.dataset.state;

            this.el.dataset.state = state.value;
        });
    }

    setup() {
        this.headroom = new Headroom(this.el, {
            offset: this.getHeight(),
            tolerance: {
                up: 10,
                down: 0,
            },
            classes: {
                initial: 'is-initialized',
                pinned: 'is-pinned',
                unpinned: 'is-unpinned',
                top: 'is-top',
                notTop: 'is-notTop',
                bottom: 'is-bottom',
                notBottom: 'is-notBottom',
            },
            onPin: () => {
                this.service.send('PIN');
            },
            onUnpin: () => {
                this.service.send('UNPIN');
            },
            onTop: () => {
                this.service.send('ABOVE_OFFSET');
            },
            onNotTop: () => {
                this.service.send('BELOW_OFFSET');
            },
        });

        this.headroom.init();
    }

    bindListeners() {
        this.on(window, 'resize', this.onWindowResize);
        this.on(document, 'scroll', this.onScroll);
    }

    onScroll(e) {
        const scrollTop = document.documentElement.scrollTop;

        if (scrollTop <= 0) {
            this.service.send('AT_PAGE_TOP');
        }
    }

    onWindowResize() {
        this.syncHeight();
    }

    syncHeight() {
        fastdom.measure(() => {
            this.height = this.getHeight();
        });

        fastdom.mutate(() => {
            document.documentElement.style.setProperty('--site-header--height', `${this.height}px`);
            this.el.classList.add('is-measured');
        });
    }

    getHeight() {
        return this.$refs.sticky.getBoundingClientRect().height;
    }

    destroy() {
        this.headroom.destroy();

        super.destroy();
    }
}
